export const shippingMethodPhoneProps = () => ({
  isEnabled: {
    type: Boolean,
    required: false,
    default: false
  },
  phoneNumber: {
    type: String,
    required: false,
    default: null
  },
  isLad: {
    type: Boolean,
    required: false,
    default: false
  }
})

export const shippingMethodPhoneEmits = () => ([
  "setAlertSmsPhone"
])

export const useShippingMethodPhone = (props, context) => {
  const tel_alerte_sms = ref(null);

  const mounted = () => {
    if (props.phoneNumber && props.isEnabled) {
      context.emit('setAlertSmsPhone', props.phoneNumber);
      tel_alerte_sms.value = props.phoneNumber;
    }
  }

  return { tel_alerte_sms, mounted }
}